const BriefCase = () => {
  return (
    <svg
      width="41"
      height="36"
      viewBox="0 0 41 36"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.0812 1.74529C14.4292 1.74529 13.9007 2.27387 13.9007 2.92592V4.97545H26.7376V2.92592C26.7376 2.27387 26.2091 1.74529 25.5571 1.74529H15.0812ZM28.4828 4.97545V2.92592C28.4828 1.30998 27.1729 0 25.5571 0H15.0812C13.4654 0 12.1555 1.30998 12.1555 2.92592V4.97545H0V33.0741C0 34.69 1.30989 36 2.92572 36H38.0743C39.6901 36 41 34.69 41 33.0741V4.97545H28.4828ZM1.74517 10.975V33.0741C1.74517 33.7261 2.27372 34.2547 2.92572 34.2547H38.0743C38.7263 34.2547 39.2548 33.7261 39.2548 33.0741V10.5962L36.1313 18.8075C35.7061 19.9252 34.6436 20.6717 33.448 20.6926L26.2389 20.8189V22.0981C26.2389 23.147 25.3886 23.9973 24.3398 23.9973H16.1737C15.1248 23.9973 14.2745 23.147 14.2745 22.0981V20.834H7.2759C6.03318 20.834 4.92606 20.0489 4.51493 18.8761L1.74517 10.975ZM14.2745 19.0887V18.3925C14.2745 17.3435 15.1248 16.4932 16.1737 16.4932H24.3398C25.3886 16.4932 26.2389 17.3435 26.2389 18.3925V19.0733L33.4174 18.9476C33.8999 18.9392 34.3286 18.638 34.5002 18.187L38.8619 6.72074H2.10314L6.16182 18.2987C6.32772 18.7719 6.77445 19.0887 7.2759 19.0887H14.2745ZM16.1737 18.2385C16.0886 18.2385 16.0197 18.3074 16.0197 18.3925V22.0981C16.0197 22.1831 16.0886 22.252 16.1737 22.252H24.3398C24.4248 22.252 24.4937 22.1831 24.4937 22.0981V18.3925C24.4937 18.3074 24.4248 18.2385 24.3398 18.2385H16.1737Z"
        fill="#004FC6"
      />
    </svg>
  );
};

export default BriefCase;
